<template lang="pug">
div
  //- BARRA DE AÇÕES
  template(v-if="acts")

    //- MENU
    v-menu(
      v-if="left"
      bottom
      left
      offset-y
    )
      template(#activator="{ on, attrs }")
        v-btn(
          v-bind="attrs"
          v-on="on"
          icon
          small
        )
          v-icon mdi-dots-vertical

      v-list(dense)
        //- Ações não agrupáveis
        action-bar-menu-item(
          v-for="(action, index) in acts.links.filter((x) => !x.category)"
          :key="`menu-${index}`"
          :action="action"
          @perform="opts => $emit('perform', { ...opts, selection: [ item ] })"
        )

        //- Ações agrupáveis
        template(v-for="(category, index) in acts.categories")
          v-subheader {{ category }}

          action-bar-menu-item(
            v-for="(action, index) in acts.links.filter((x) => x.category === category)",
            :key="`menu-${category}-${index}`",
            :action="action",
            @perform="opts => perform({ ...opts, selection: [ item ] })"
          )

    //- BOTOES
    v-tooltip(
      v-for="(action, index) in pins",
      :key="`action-${index}`",
      bottom
    )
      template(#activator="{ on, attrs }")

        //- BOTAO QUANDO EXISTE APENAS UM LINK PRIMARIO
        v-btn.x-icon.px-0.mx-0(
          v-bind="attrs",
          v-on="on",
          :text="isText(action)",
          :icon="!isText(action)",
          small,
          @click="$emit('perform', { link: action, selection: [ item ] })"
        )
          span.pr-1(
            v-if="isText(action)"
          )

          v-icon.mx-0(
            v-if="isIcon(action)"
            small
            left
            :color="getColor(action)"
          )
            | {{ getIcon(action) }}

          span.pr-1(
            v-if="isText(action)"
            :class="getClass(action)"
          )
            | {{ action.title || action.name }}

        //- //- TODO: ainda não suportado. os menus deveriam ser agrupados em categorias e deveriam haver icones de categoria.
        //- //- MENU QUANDO EXISTEM VARIOS LINKS PRIMARIOS
        //- v-menu(
        //-   bottom
        //-   left
        //-   offset-y
        //- )
        //-   template(#activator="{ on, attrs }")
        //-     v-btn.x-icon.px-0.mx-0(
        //-       v-bind="attrs",
        //-       v-on="on",
        //-       :text="isText(action)",
        //-       :icon="!isText(action)",
        //-       small
        //-     )
        //-       span.pr-1(
        //-         v-if="isText(action)"
        //-       )

        //-       v-icon.mx-0(
        //-         v-if="isIcon(action)"
        //-         small
        //-         left
        //-       )
        //-         | {{ action.icon }}

        //-       span.pr-1(
        //-         v-if="isText(action)"
        //-       )
        //-         | {{ action.title || action.name }}

        //-   v-list(dense)
        //-     //- Ações não agrupáveis
        //-     action-bar-menu-item(
        //-       v-for="(action, index) in acts.links.filter((x) => !x.category)"
        //-       :key="`menu-${index}`"
        //-       :action="action"
        //-       @perform="opts => perform({ ...opts, selection: [ item ] })"
        //-     )

        //-     //- Ações agrupáveis
        //-     template(v-for="(category, index) in acts.categories")
        //-       v-subheader {{ category }}

        //-       action-bar-menu-item(
        //-         v-for="(action, index) in acts.links.filter((x) => x.category === category)",
        //-         :key="`menu-${category}-${index}`",
        //-         :action="action",
        //-         @perform="opts => perform({ ...opts, selection: [ item ] })"
        //-       )


      span
        span.text-md.font-weight-medium {{ action.title || action.name }}
        br
        span.font-weight-light {{ action.description }}

    //- MENU
    v-menu(
      v-if="right"
      bottom
      left
      offset-y
    )
      template(#activator="{ on, attrs }")
        v-btn.mr-4(
          v-bind="attrs"
          v-on="on"
          icon
          small
        )
          v-icon mdi-dots-vertical

      v-list(dense)
        //- Ações não agrupáveis
        action-bar-menu-item(
          v-for="(action, index) in acts.links.filter((x) => !x.category)"
          :key="`menu-${index}`"
          :action="action"
          @perform="opts => perform({ ...opts, selection: [ item ] })"
        )

        //- Ações agrupáveis
        template(v-for="(category, index) in acts.categories")
          v-subheader {{ category }}

          action-bar-menu-item(
            v-for="(action, index) in acts.links.filter((x) => x.category === category)",
            :key="`menu-${category}-${index}`",
            :action="action",
            @perform="opts => perform({ ...opts, selection: [ item ] })"
          )


  //- CÉLULA COMUM
  template(v-else)

    v-tooltip(
      bottom
      :class="tooltipClass",
      :color="tooltipColor"
      :disabled="!tooltipEnabled"
    )
      template(#activator="{ on, attrs }")

        div(
          v-bind="attrs"
          v-on="on"
          :class="cellFontStyle"
        )

          x-chip(
            :value="!!(useBadge && value)",
            :link="!!primaryLink",
            :color="cellColor || 'primary'",
            @actionPerformed="call(primaryLink)"
          )
            template(v-if="useIcon")

              v-icon(
                v-if="primaryLink"
                :color="cellColor"
                @click.stop="call(primaryLink)"
                :small="!isLarge"
              )
                | {{ value }}

              v-icon(
                v-else
                :color="cellColor"
                :small="!isLarge"
              )
                | {{ value }}

            template(v-else-if="dataType === 'Boolean'")
              v-icon(
                v-if="primaryLink"
                v-for="icon in [formatIcon(value)]"
                :key="`${icon.name}-primary-link`"
                :color="icon.color"
                small
                @click.stop="call(primaryLink)"
              )
                | {{ icon.name }}

              v-icon(
                v-else
                v-for="icon in [formatIcon(value)]"
                :key="icon.name"
                :color="icon.color"
                small
              )
                | {{ icon.name }}

            template(v-else-if="primaryLink && !useBadge && primaryLink.href")
              a.x-link(
                :target="primaryLink.href"
                :href="primaryLink.href"
              )
                | {{ formattedValue }}

            template(v-else-if="primaryLink && !useBadge")
              router-link.x-link(
                is="a",
                :class="useBadge ? null : cellClass",
                @click.stop="call(primaryLink)"
              )
                | {{ formattedValue }}

            template(v-else)
              div(
                :class="useBadge ? 'x-badge-cell' : cellClass"
              )
                | {{ formattedValue }}

      span
        span.text-md.font-weight-medium(v-if="tooltipTitle") {{ tooltipTitle }}
        br(v-if="tooltipTitle && tooltipText")
        span.font-weight-light(v-if="tooltipText") {{ tooltipText }}

</template>

<style scoped>
.x-link {
  /* color: var(--v-primary-base); */
  color: inherit;
  text-decoration: underscore;
}
.x-badge-cell {
  font-weight: 600;
}
.x-icon {
  padding: 0 !important;
  min-width: auto !important;
}
/* Estilos de texto */
.x-bold { font-weight: bold !important; }
.x-italic { font-style: italic !important; }
.x-overline { text-decoration: overline !important; }
.x-strike-through { text-decoration: line-through !important; }
.x-underline { text-decoration: underline !important; }
.x-monospace { font-family: 'Courier New', Courier, monospace !important; }

</style>

<script>
import { getDate, getDateTime } from '@/helpers/dates'
import { hasRel, findRel, findRels } from "@/helpers/rels"
import XChip from "./XChip"
import ActionBarMenuItem from "@/components/commons/action-bar/ActionBarMenuItem"
import { computeAll } from "@/helpers/conditions"
import {
  ITALIC, BOLD, OVERLINE, STRIKETHROUGH, UNDERLINE, MONOSPACE,
  selectClass, selectColor, hasFontStyle
} from "@/helpers/styles"

export default {
  components: {
    XChip,
    ActionBarMenuItem,
  },

  props: {
    item: Object,
    col: Object,
  },

  computed: {
    row() {
      return this.item?.["@row"] || {}
    },

    cell() {
      const cell = this.item?.[this.col.value]
      return (typeof cell === "object" ? cell : { value: cell }) || {}
    },

    value() {
      return this.cell.value
    },

    isLarge() {
      return hasRel(this.cell, 'Large')
    },

    isDisabled() {
      return !!this.cell.disabled
    },

    pins() {
      const actions = this.col.header.actions
      if (!actions?.criteria) return null

      let items = this.row.links || []
      computeAll(items, this.context)
      items = items.filter((item) => !item.hidden)

      items = findRels(items, actions.criteria)
      return items
    },

    acts() {
      const actions = this.col.header.actions
      if (!actions) return null

      let items = this.row.links || []
      computeAll(items, this.context)
      items = items.filter((item) => !item.hidden)

      items = findRels(items, "Action")
      const links = [
        ...findRels(items, "Primary"),
        ...findRels(items, "Secondary"),
        ...findRels(items, { excludes: ["Primary", "Secondary"] }),
      ]
      if (!links.length) return null

      const categories = [
        ...new Set(links.filter((x) => !!x.category).map((x) => x.category)),
      ]
      return { categories, links }
    },

    pinned() {
      return !!this.col.header.actions?.pinned
    },

    left() {
      return this.col.header.actions?.pinned === "left"
    },

    right() {
      return this.col.header.actions?.pinned === "right"
    },

    useBadge() {
      return this.col.useBadge || hasRel(this.cell, "Badge")
    },

    useIcon() {
      return this.col.useIcon || hasRel(this.cell, "Icon")
    },

    dataType() {
      const dataType = this.col.header.dataType
      if (dataType !== 'Object') return dataType || 'String'

      const value = this.value

      if (typeof value === 'boolean') return 'Boolean'
      if (typeof value === 'number') return value.toString().includes('.') ? 'Decimal' : 'Integer'

      if (value) {
        if (value.match(/^\d{4}-\d{2}-\d{2}T00:00:00$/)) return 'Date'
        if (value.match(/^\d{4}-\d{2}-\d{2}$/)) return 'Date'
        if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) return 'DateTime'
        if (value.match(/^\d{1,2}:\d{2}:\d{2}/)) return 'Time'
        if (value.match(/^\d+.\d{1,2}:\d{2}:\d{2}/)) return 'TimeSpan'
      }

      return 'String'
    },

    // Obtém o valor de uma célula formatado
    formattedValue() {
      const format = this[`format${this.dataType}`]
      const value = format?.call(this, this.value) || this.value
      return value
    },

    links() {
      return this.cell.links || []
    },

    rowLink() {
      if (!this.row.links) return null
      return findRel(this.row.links, {
        includes: ["Action", "Primary"],
        excludes: ["Pinned"],
      })
    },

    cellLink() {
      if (!this.cell.links) return null
      return findRel(this.cell.links, {
        includes: ["Action", "Primary"],
        excludes: ["Pinned"],
      })
    },

    primaryLink() {
      return this.cellLink || this.rowLink
    },

    cellFontStyle() {
      const { cell, col, row } = this
      const font = cell?.font || col?.font || row?.font || 0
      const isSummary = hasRel(cell, "Summary") || hasRel(col, "Summary") || hasRel(row, "Summary")
      return {
        'x-italic': hasFontStyle(font, ITALIC),
        'x-bold': isSummary || hasFontStyle(font, BOLD),
        'x-overline': hasFontStyle(font, OVERLINE),
        'x-strike-through': hasFontStyle(font, STRIKETHROUGH),
        'x-underline': hasFontStyle(font, UNDERLINE),
        'x-monospace': hasFontStyle(font, MONOSPACE),
      }
    },

    cellClass() {
      const { cell, col, row } = this
      return selectClass(cell?.style || col?.style || row?.style)
    },

    cellColor() {
      const { cell, col, row } = this

      const color = cell?.color || col?.color || row?.color
      if (color) return color

      const style = cell?.style || col?.style || row?.style
      if (style) return selectColor(style)

      return this.cellLink ? "primary" : null
    },

    tooltipTitle() {
      if (this.cell.tooltip) return this.cell.tooltip.title
      const link = this.primaryLink
      return link?.title || link?.verb || link?.name || link?.eref
    },

    tooltipText() {
      return this.cell.tooltip?.text || this.primaryLink?.description
    },

    tooltipEnabled() {
      return !!(this.tooltipTitle || this.tooltipText)
    },

    tooltipClass() {
      const tooltip = this.cell.tooltip
      return selectClass(tooltip?.style)
    },

    tooltipColor() {
      const tooltip = this.cell.tooltip
      if (tooltip?.color) return tooltip?.color
      if (tooltip?.style) return selectColor(tooltip?.style)
      return null
    },

    context() {
      return { ...this.item }
    },
  },

  methods: {
    hasMember(host, member) {
      return Object.prototype.hasOwnProperty?.call(host, member)
    },

    formatIcon(value) {
      if (value === true || value === 1) {
        return { name: "mdi-check" }
      }
      if (value === false || value === 0) {
        return { name: "mdi-minus", color: "#7777" }
      }
      return {}
    },

    formatInteger(value) {
      if (this.value === null || this.value === undefined) return '-'
      return value
    },

    formatLong(value) {
      if (this.value === null || this.value === undefined) return '-'
      return value
    },

    formatDecimal(value) {
      if (this.value === null || this.value === undefined) return '-'
      const formatter = Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
      })
      return formatter.format(value)
    },

    formatDate(value) {
      if (this.value === null || this.value === undefined) return '-'
      return getDate(value)
    },

    formatTime(value) {
      if (this.value === null || this.value === undefined) return '-'
      // TODO: Ainda não implementado.
      return value
    },

    formatDateTime(value) {
      if (this.value === null || this.value === undefined) return '-'
      return getDateTime(value)?.replace(" 00:00:00", "")
    },

    isText(link) {
      return !link.icon || hasRel(link, "Text")
    },

    isIcon(link) {
      return !!link.icon
    },

    getIcon(link) {
      const pin = link.states?.filter(state => state.name === 'Pin')[0] || link
      return pin.icon || link.icon
    },

    getClass(link) {
      const pin = link.states?.filter(state => state.name === 'Pin')[0] || link
      const clazz = selectClass(pin.style || link.style)
      return clazz
    },

    getColor(link) {
      const pin = link.states?.filter(state => state.name === 'Pin')[0] || link

      const color = pin.color || link.color
      if (color) return color

      const style = pin.style || pin.style
      if (style) return selectColor(style)

      return null
    },

    call(link) {
      if (link?.eref) {
        this.$emit("perform", { link, selection: [this.item] })
        return
      }
      if (link?.href) {
        // window.open(url, windowName, [windowFeatures])
        var window = window.open(link.href, link.href)
        window.addEventListener(
          "load",
          () => {
            var document = document.getElementById()
          },
          true
        )

        return
      }
    },
  },
}
</script>
